import type {SavedViewVisibility} from '../types'

export type ViewWithVisibility = {
  // The generated proto type for this field is a plain string so the union cannot be
  // used here. Any value other than 'personal' resolves to the default.
  visibility: SavedViewVisibility | (string & {})
}

export const DEFAULT_VIEW_VISIBILITY: SavedViewVisibility = 'team'

export const VIEW_VISIBILITY_PARAMS: Record<SavedViewVisibility, string> = {
  personal: 'private',
  team: 'shared',
}

export function viewVisibilityFromParam(value: string | null): SavedViewVisibility | undefined {
  if (value === 'private') return 'personal'
  if (value === 'shared') return 'team'
  return undefined
}

export function viewVisibility(view: ViewWithVisibility): SavedViewVisibility {
  return view.visibility === 'personal' ? 'personal' : DEFAULT_VIEW_VISIBILITY
}

export function splitViewsByVisibility<View extends ViewWithVisibility>(
  views: readonly View[],
): {
  team: View[]
  personal: View[]
} {
  const team: View[] = []
  const personal: View[] = []

  for (const view of views) {
    if (viewVisibility(view) === 'personal') {
      personal.push(view)
    } else {
      team.push(view)
    }
  }

  return {team, personal}
}
